import { post as $post } from './core/fetch';

export const get_historical_data = (resource_id, start_date, end_date) => $post('/historical-data', { resource_id, start_date, end_date });
export const update_historical_data = (data) => $post('/historical-data-update', data);
